import React from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowRight,
  faArrowDown,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import MyIcon from "../Common/MyIcon";
import InputLabel from "../Builder/nodes/Logic/Inputs/InputLabel";
import { InputGroup } from "react-bootstrap";

function WeatherConditionValueSelector({
  detail,
  index,
  detailIndex,
  handleConditionDetailChange,
}) {
  // Handle weather codes
  if (detail.selectedCondition.codes) {
    if (detail.ConditionOperator === "betweenx") {
      return (
        <>
          <InputLabel>Condition Value</InputLabel>
          <div className="d-flex gap-2">
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              value={
                detail.ConditionValue[0] !== undefined
                  ? {
                      value: detail.ConditionValue[0],
                      label: detail.selectedCondition.codes.find(
                        (code) => code.value === detail.ConditionValue[0]
                      )?.label,
                    }
                  : null
              }
              onChange={(selected) => {
                const min = selected ? parseFloat(selected.value) : null;
                const max =
                  detail.ConditionValue[1] !== undefined
                    ? detail.ConditionValue[1]
                    : null;
                handleConditionDetailChange(
                  detailIndex,
                  "ConditionValue",
                  [min, max],
                  index
                );
              }}
              formatOptionLabel={formatWeatherCodeOption(detail)}
              options={filterWeatherCodes(detail)}
              placeholder="Min"
            />{" "}
            <span className="align-self-center">and</span>
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              value={
                detail.ConditionValue[1] !== undefined
                  ? {
                      value: detail.ConditionValue[1],
                      label: detail.selectedCondition.codes.find(
                        (code) => code.value === detail.ConditionValue[1]
                      )?.label,
                    }
                  : null
              }
              onChange={(selected) => {
                const min =
                  detail.ConditionValue[0] !== undefined
                    ? detail.ConditionValue[0]
                    : null;
                const max = selected ? parseFloat(selected.value) : null;
                handleConditionDetailChange(
                  detailIndex,
                  "ConditionValue",
                  [min, max],
                  index
                );
              }}
              formatOptionLabel={formatWeatherCodeOption(detail)}
              options={filterWeatherCodes(detail)}
              placeholder="Max"
            />
          </div>
        </>
      );
    }
    return (
      <>
        <InputLabel>Condition Value</InputLabel>
        <Select
          isMulti={
            detail.ConditionOperator === "=" ||
            detail.ConditionOperator === "between"
          }
          key={detail.Condition}
          className="react-select-container"
          classNamePrefix="react-select"
          value={detail.ConditionValue.map((val) => ({
            value: val,
            label: detail.selectedCondition.codes.find(
              (code) => code.value === val
            )?.label,
          }))}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? Array.isArray(selectedOptions)
                ? selectedOptions.map((option) => parseFloat(option.value))
                : [parseFloat(selectedOptions.value)]
              : [];
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              values,
              index
            );
          }}
          formatOptionLabel={formatWeatherCodeOption(detail)}
          options={filterWeatherCodes(detail)}
        />
      </>
    );
  }
  // Handle wind directions
  if (detail.selectedCondition.windDirections) {
    return (
      <>
        <InputLabel>Wind Direction</InputLabel>
        <Select
          isMulti
          key={detail.Condition}
          className="react-select-container"
          classNamePrefix="react-select"
          value={detail.ConditionValue.map((val) => ({
            value: val,
            label: detail.selectedCondition.windDirections.find(
              (dir) => dir.degrees === val
            )?.direction,
          }))}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? Array.isArray(selectedOptions)
                ? selectedOptions.map((option) => parseFloat(option.value))
                : [parseFloat(selectedOptions.value)]
              : [];
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              values,
              index
            );
          }}
          formatOptionLabel={formatWindDirectionOption}
          options={detail.selectedCondition.windDirections.map((d) => ({
            value: d.degrees,
            label: d.direction,
          }))}
        />
      </>
    );
  }
  // Handle numeric inputs

  if (detail.ConditionOperator === "between") {
    return (
      <div className="d-flex gap-2">
        <Input
          key={`${detail.Condition}-min`}
          type="number"
          label="Min Value"
          value={[detail.ConditionValue[0]]}
          onChange={(values) => {
            const min = parseFloat(values[0]);
            const max =
              detail.ConditionValue[1] !== undefined
                ? detail.ConditionValue[1]
                : null;
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              [min, max],
              index
            );
          }}
        />
        <span className="align-self-center">and</span>
        <Input
          key={`${detail.Condition}-max`}
          type="number"
          label="Max Value"
          value={[detail.ConditionValue[1]]}
          onChange={(values) => {
            const min =
              detail.ConditionValue[0] !== undefined
                ? detail.ConditionValue[0]
                : null;
            const max = parseFloat(values[0]);
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              [min, max],
              index
            );
          }}
        />
      </div>
    );
  }
  return (
    <Input
      key={detail.Condition}
      type="number"
      label="Condition Value"
      value={[detail.ConditionValue[0]]}
      onChange={(values) =>
        handleConditionDetailChange(
          detailIndex,
          "ConditionValue",
          [parseFloat(values[0])],
          index
        )
      }
    />
  );
}

// Helper function for weather code options
const formatWeatherCodeOption = (detail) =>
  function (option) {
    const icon = detail.selectedCondition.codes.find(
      (a) => a.label === option.label
    )?.icon;
    return (
      <div className="d-flex align-items-center gap-2 bg-transparent">
        {icon && (
          <MyIcon
            width="16"
            height="16"
            Icon={icon}
            className="text-purple bg-transparent"
          />
        )}
        {option.label}
      </div>
    );
  };

// Helper function for wind direction options with just cardinal directions
const formatWindDirectionOption = (option) => (
  <div className="d-flex align-items-center gap-2">
    {/* Use FontAwesomeIcon with rotation */}
    <FontAwesomeIcon
      icon={faArrowUp} // Always use faArrowUp as the base icon
      className="text-purple"
      style={{ transform: `rotate(${option.value}deg)` }} // Rotate based on degrees
    />
    {option.label}
  </div>
);

const filterWeatherCodes = (detail) =>
  detail.selectedCondition.codes
    .filter(
      (code) =>
        code.time === null ||
        code.time === (detail.TimeOfDay === "day" ? "day" : "night")
    )
    .map((code) => ({
      value: code.value,
      label: code.label,
    }));

export default WeatherConditionValueSelector;
